import React from 'react';

import { Glossary, CommonGL } from 'common/utils/glossary';
import { Button } from 'common/components';
import { MenuButton, UserButton } from 'common/containers';

interface HeaderProps {
  /** ホームボタンを表示するか否か */
  isDisplayHome: boolean;
  /** 初期化処理が完了したか否か */
  isCompleteInit: boolean;
  /** ログイン済みか否か */
  isLoggedIn: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** ログインボタンの押下時の処理 */
  onClickLogin: () => void;
  /** ホームボタンの押下時の処理 */
  onClickHome: () => void;
}

/**
 * ヘッダーのPresentation Component
 */
export const Header: React.FC<HeaderProps> = ({
  isDisplayHome,
  isCompleteInit,
  isLoggedIn,
  onClickLogin,
  onClickHome,
  glossary
}) => {
  return (
    <section id="header">
      <div id="headerInner">
        {/* プラン一覧画面・エラー画面・購入完了画面以外は戻るボタンあり */}
        {isDisplayHome && isCompleteInit ? (
          <Button
            type="toolButton"
            subType="home"
            data-test="headerHomeButton"
            onClick={onClickHome}
          />
        ) : (
          <div className="headerItem" />
        )}
        <div className="headerItem" />
        {/* タイトル */}
        {isCompleteInit ? (
          <div className="headerTitle" />
        ) : (
          <div className="headerItem" />
        )}

        {/* 初期化処理が完了済みか、ログイン済みか否かでアイコン変更 */}
        {isCompleteInit ? (
          isLoggedIn ? (
            <UserButton data-test="headerUserButton" />
          ) : (
            <Button
              type="loginButton"
              data-test="headerLoginButton"
              onClick={onClickLogin}
            >
              {glossary.glx(CommonGL.LoginBtnTitle)}
            </Button>
          )
        ) : (
          <div className="headerItem" />
        )}
        {/* 初期化処理が完了済みか否かで表示・非表示を切り替え */}
        {isCompleteInit ? (
          <MenuButton data-test="headerMenuButton" />
        ) : (
          <div className="headerItem" />
        )}
      </div>
    </section>
  );
};
